import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["fileInput", "fileList"]
    static values = {
        maxFiles: Number
    }


    connect() {
        this.files = []
    }

    handleFileSelect(event) {
        const files = Array.from(event.target.files)
        for (const file of files) {
            if (file.size > 5 * 1024 * 1024) {
                alert(`File size of ${file.name} is too large, please upload a file less than 5MB`)
                return false
            }
        }

        if (this.files.length + files.length > this.maxFilesValue) {
            alert(`You can only upload up to ${this.maxFilesValue} files.`)
            return false
        }
        this.files = [...this.files, ...files]
        this.updateFileList()
    }

    removeFile(event) {
        const fileName = event.target.dataset.fileName
        this.files = this.files.filter(file => file.name !== fileName)
        this.updateFileList()
    }

    updateFileList() {
        this.fileListTarget.innerHTML = ""
        this.files.forEach(file => {
            const listItem = document.createElement("li")
            listItem.classList.add("flex", "items-center", "gap-x-2", "text-sm", "text-gray-400")
            const fileName = document.createElement("span")
            fileName.classList.add("text-sm", "text-gray-300")
            fileName.textContent = file.name.length > 20 ? file.name.slice(0, 10) + "..." + file.name.slice(-10) : file.name

            const removeButton = document.createElement("button")
            removeButton.classList.add("text-xs", "text-red-500", "hover:text-red-700")
            removeButton.textContent = "Remove"
            removeButton.dataset.fileName = file.name;

            removeButton.addEventListener("click", this.removeFile.bind(this))
            listItem.appendChild(fileName)
            listItem.appendChild(removeButton)
            this.fileListTarget.appendChild(listItem)
        })
    }
}